<template>
  <div class="project_thumbnail">
    <svg
      v-if="type == 'inbox'"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_210)">
        <path
          d="M11.8426 0.357147H3.15693C1.61054 0.357147 0.356934 1.61075 0.356934 3.15715V11.8429C0.356934 13.3893 1.61054 14.6429 3.15693 14.6429H11.8426C13.389 14.6429 14.6426 13.3893 14.6426 11.8429V3.15715C14.6426 1.61075 13.389 0.357147 11.8426 0.357147Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M14.6426 9.57144H8.85693"
          stroke="#0077FF"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M5.57836 9.57144H0.356934"
          stroke="#0077FF"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M5.57877 9.57144C5.56395 9.79582 5.59535 10.0208 5.67102 10.2326C5.7467 10.4443 5.86504 10.6383 6.01871 10.8025C6.17238 10.9666 6.35812 11.0975 6.56442 11.1869C6.77072 11.2764 6.99319 11.3226 7.21805 11.3226C7.44292 11.3226 7.66539 11.2764 7.87168 11.1869C8.07798 11.0975 8.26372 10.9666 8.4174 10.8025C8.57107 10.6383 8.68941 10.4443 8.76508 10.2326C8.84076 10.0208 8.87216 9.79582 8.85734 9.57144"
          stroke="#0077FF"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_210">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="type == 'today'"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_221)">
        <path
          d="M5.28564 1.87143H6.04279H9.04279H9.71422"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M11.2784 1.87142H12.5284C12.7936 1.85401 13.0596 1.88925 13.3111 1.97512C13.5626 2.06098 13.7947 2.19578 13.9939 2.37173C14.1931 2.54768 14.3555 2.76131 14.4717 3.00031C14.588 3.23931 14.6558 3.49896 14.6712 3.76428V5.10714H0.356934V3.76428C0.372384 3.49896 0.44019 3.23931 0.556442 3.00031C0.672694 2.76131 0.835095 2.54768 1.03429 2.37173C1.23348 2.19578 1.46552 2.06098 1.71704 1.97512C1.96856 1.88925 2.23459 1.85401 2.49979 1.87142H3.72122"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M14.6429 5.10715V12.75C14.6274 13.0153 14.5596 13.275 14.4434 13.514C14.3271 13.753 14.1647 13.9666 13.9655 14.1426C13.7664 14.3185 13.5343 14.4533 13.2828 14.5392C13.0313 14.625 12.7652 14.6603 12.5 14.6429H2.47147C2.20627 14.6603 1.94024 14.625 1.68872 14.5392C1.4372 14.4533 1.20516 14.3185 1.00597 14.1426C0.806775 13.9666 0.644374 13.753 0.528122 13.514C0.411869 13.275 0.344064 13.0153 0.328613 12.75V5.10715H14.6429Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M5.28549 1.05713V2.6857C5.28589 2.78517 5.26552 2.88362 5.22567 2.97475C5.18582 3.06589 5.12738 3.1477 5.05409 3.21494C4.98079 3.28218 4.89426 3.33337 4.80004 3.36524C4.70582 3.39711 4.60598 3.40894 4.50691 3.39999C4.40729 3.41 4.30667 3.39896 4.21159 3.36757C4.11651 3.33619 4.02908 3.28517 3.955 3.21781C3.88091 3.15046 3.82181 3.06828 3.78153 2.97661C3.74125 2.88494 3.7207 2.78583 3.7212 2.6857V1.05713C3.7207 0.957004 3.74125 0.857891 3.78153 0.766221C3.82181 0.674552 3.88091 0.592374 3.955 0.525021C4.02908 0.457668 4.11651 0.406644 4.21159 0.375259C4.30667 0.343875 4.40729 0.332831 4.50691 0.342845C4.70952 0.3417 4.9054 0.415473 5.05691 0.549988C5.13056 0.612008 5.18933 0.689779 5.22889 0.777556C5.26846 0.865334 5.2878 0.960878 5.28549 1.05713V1.05713Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M11.2786 1.05715V2.68572C11.26 2.88026 11.1696 3.06089 11.025 3.19233C10.8803 3.32378 10.6919 3.39661 10.4965 3.39661C10.3011 3.39661 10.1127 3.32378 9.96804 3.19233C9.82342 3.06089 9.73297 2.88026 9.71436 2.68572V1.05715C9.71396 0.957686 9.73433 0.859233 9.77418 0.768098C9.81403 0.676963 9.87247 0.595155 9.94576 0.527913C10.0191 0.460672 10.1056 0.409479 10.1998 0.377613C10.294 0.345748 10.3939 0.333912 10.4929 0.342865C10.6978 0.341303 10.896 0.415017 11.0501 0.550008C11.1222 0.613298 11.1799 0.691313 11.2194 0.778795C11.2588 0.866277 11.279 0.961195 11.2786 1.05715V1.05715Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_221">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="type == 'assigned_to_me'"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_227)">
        <path
          d="M11.8426 0.357147H3.15693C1.61054 0.357147 0.356934 1.61075 0.356934 3.15715V11.8429C0.356934 13.3893 1.61054 14.6429 3.15693 14.6429H11.8426C13.389 14.6429 14.6426 13.3893 14.6426 11.8429V3.15715C14.6426 1.61075 13.389 0.357147 11.8426 0.357147Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M7.50018 12.2429C10.1196 12.2429 12.243 10.1194 12.243 7.5C12.243 4.88059 10.1196 2.75714 7.50018 2.75714C4.88077 2.75714 2.75732 4.88059 2.75732 7.5C2.75732 10.1194 4.88077 12.2429 7.50018 12.2429Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M5.08594 6.95715L7.05737 8.92858"
          stroke="#0077FF"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.05713 8.92858L9.91427 6.07144"
          stroke="#0077FF"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_227">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="type == 'high_priority'"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_232)">
        <path
          d="M12.4712 0.357147H2.52836C1.32912 0.357147 0.356934 1.32933 0.356934 2.52858V12.4714C0.356934 13.6707 1.32912 14.6429 2.52836 14.6429H12.4712C13.6705 14.6429 14.6426 13.6707 14.6426 12.4714V2.52858C14.6426 1.32933 13.6705 0.357147 12.4712 0.357147Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M7.50173 3H7.49827C7.22308 3 7 3.33006 7 3.7372V8.2628C7 8.66994 7.22308 9 7.49827 9H7.50173C7.77692 9 8 8.66994 8 8.2628V3.7372C8 3.33006 7.77692 3 7.50173 3Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M7.5 12C7.77614 12 8 11.7761 8 11.5C8 11.2239 7.77614 11 7.5 11C7.22386 11 7 11.2239 7 11.5C7 11.7761 7.22386 12 7.5 12Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_232">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else-if="type == 'medium_priority'"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_123_236)">
        <path
          d="M12.4712 0.357147H2.52836C1.32912 0.357147 0.356934 1.32933 0.356934 2.52858V12.4714C0.356934 13.6707 1.32912 14.6429 2.52836 14.6429H12.4712C13.6705 14.6429 14.6426 13.6707 14.6426 12.4714V2.52858C14.6426 1.32933 13.6705 0.357147 12.4712 0.357147Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M3.5 8C3.77614 8 4 7.77614 4 7.5C4 7.22386 3.77614 7 3.5 7C3.22386 7 3 7.22386 3 7.5C3 7.77614 3.22386 8 3.5 8Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
        <path
          d="M11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z"
          stroke="#0077FF"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_236">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
    <svg
      v-else
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5.54348C15 5.62996 14.9656 5.7129 14.9045 5.77406C14.8433 5.83521 14.7604 5.86957 14.6739 5.86957H0.326087C0.239603 5.86957 0.156662 5.83521 0.0955087 5.77406C0.0343556 5.7129 0 5.62996 0 5.54348C0 5.457 0.0343556 5.37405 0.0955087 5.3129C0.156662 5.25175 0.239603 5.21739 0.326087 5.21739H14.6739C14.7604 5.21739 14.8433 5.25175 14.9045 5.3129C14.9656 5.37405 15 5.457 15 5.54348ZM0.326087 0.652174H14.6739C14.7604 0.652174 14.8433 0.617819 14.9045 0.556666C14.9656 0.495512 15 0.412571 15 0.326087C15 0.239603 14.9656 0.156662 14.9045 0.0955087C14.8433 0.0343556 14.7604 0 14.6739 0H0.326087C0.239603 0 0.156662 0.0343556 0.0955087 0.0955087C0.0343556 0.156662 0 0.239603 0 0.326087C0 0.412571 0.0343556 0.495512 0.0955087 0.556666C0.156662 0.617819 0.239603 0.652174 0.326087 0.652174ZM14.6739 10.4348H0.326087C0.239603 10.4348 0.156662 10.4691 0.0955087 10.5303C0.0343556 10.5914 0 10.6744 0 10.7609C0 10.8474 0.0343556 10.9303 0.0955087 10.9914C0.156662 11.0526 0.239603 11.087 0.326087 11.087H14.6739C14.7604 11.087 14.8433 11.0526 14.9045 10.9914C14.9656 10.9303 15 10.8474 15 10.7609C15 10.6744 14.9656 10.5914 14.9045 10.5303C14.8433 10.4691 14.7604 10.4348 14.6739 10.4348Z"
        fill="#0077FF"
      />
    </svg>
    <!-- <span v-if="type == 'today'">{{ nowDay }}</span> -->
  </div>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      nowDay: new Date().getDate(),
    };
  },
};
</script>
